import { Box, Typography } from "@mui/material";
import { PaginationBlock } from "../PaginationBlock";

export const EasPagination = ({ total, isLoading }: { total: number; isLoading: boolean }) => {
	if (!total) return null;
	return <Box
	sx={{
		padding: '0 20px 20px 20px',
		display: 'flex',
		justifyContent: 'space-between',
	}}
>
	<PaginationBlock total={total} isLoading={isLoading} />
	{!!total && (
		<Box
			sx={{
				pt: '20px',
				display: 'flex',
				flexDirection: 'row',
			}}
		>
			<Typography
				sx={{
					fontSize: '1rem',
					color: '#555',
				}}
			>
				{total ? `Total items: ` : ''}
			</Typography>
			&nbsp;
			<Typography
				sx={{
					fontSize: '1rem',
					fontWeight: 'bold',
					color: 'primary.main',
				}}
			>
				{total
					? `${new Intl.NumberFormat('en-EN', { style: 'decimal' }).format(total)} `
					: 'No data found'}
			</Typography>
		</Box>
	)}
</Box>;

};